import { Box, Grid, styled, Typography } from "@mui/material";
import React from "react";
import TurnoPromiseComponent from "../../SDK/FAQ/turnoPromiseComponent";

const CustomerBrandPromises = styled(Box)(({ theme }) => ({
  width: "100vw",
  display: "flex",
  alignItems: "center",
  minHeight: "400px",
  flexDirection: "column",
  paddingLeft: "8%",
  paddingRight: "8%",
  marginTop: "48px",
  paddingTop: "12px",
  ".vehicles-grid-container": {
    padding: "0",
    display: "flex",
    justifyContent: "flex-start",
  },
  ".promiseHeader": {
    fontSize: "24px",
    fontWeight: "700",
    letterSpacing: "0em",
    textAlign: "left",
  },
  [theme.breakpoints.down("md")]: {
    padding: "10px",
    marginTop: "24px",
  },
  [theme.breakpoints.down("sm")]: {
    ".promiseHeader": {
      fontSize: "24px",
    },
  },
  ".promiseHeader": {
    fontSize: "24px",
  },
  [theme.breakpoints.down("md")]: {
    padding: "10px",
    marginTop: "24px",
  },
  [theme.breakpoints.down("sm")]: {
    ".promiseHeader": {
      fontSize: "24px",
    },
  },
}));

const BrandPromises = ({ promisesData }) => {
  return (
    <CustomerBrandPromises>
      <Grid
        container
        spacing={3}
        className="vehicles-grid-container"
        id="search-result"
      >
        {promisesData?.headerInfo && promisesData?.headerInfo?.length > 0 && (
          <Grid item xs={12}>
            <Typography
              variant="h2"
              className="promiseHeader"
              sx={{
                padding: { xs: "0 12px", md: "0" },
                fontSize: { xs: "24px", md: "24px" },
                fontWeight: "700 !important",
              }}
            >
              {promisesData?.headerInfo}
            </Typography>
          </Grid>
        )}

        <Grid item xs={12}>
          <TurnoPromiseComponent
            headerInfo={promisesData?.subHeaderText || ""}
            promiseData={promisesData?.promiseList}
          />
        </Grid>
      </Grid>
    </CustomerBrandPromises>
  );
};

const MemoizedBrandPromises = React.memo(BrandPromises);
export default MemoizedBrandPromises;
